export default __webpack_public_path__ + "static/media/Valentine_s love wreath.a8c39d76.jpg";